import { useContext } from "react";
import { DialogContext } from "../../context/dialog";

export const useDialog = () => {
  return useContext(DialogContext);
};
